<template>
    <div>
        <!-- <div @click="ding" style="color:#fff;">顶部</div>
        <div @click="jiapl" style="color:#fff;">加评论</div> -->
        <!-- <div class="barrage-list barrage-list_1" :style="chujiaData.length>3?'height:4.5rem;bottom:'+jinerBottom+'px;':'height:'+1.5*(chujiaData.length)+'rem;bottom:'+jinerBottom+'px;'"> -->
        <div :class="chujiaClass" :style="chujiaData.length>3?'height:4.5rem;bottom:'+jinerBottom+'px;':'height:'+1.5*(chujiaData.length)+'rem;bottom:'+jinerBottom+'px;'">
            <!-- <div class="barrage-box" :style="chujiaData.length>3?'top:'+(1.5*(chujiaData.length-3)*-1)+'rem;':''"> -->
            <div class="barrage-box" v-if="contShow">
                <template v-for="(item,index) in chujiaData">
                    <div class="barrage-list_box" :key="index" v-if="index<3">
                        <div class="barrage-list_con van-ellipsis">
                            <span>{{item.name}}：</span>{{item.currency_type}} {{item.money}}
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <div :class="jinruClass" :style="'bottom:'+jinBottom+'px;'">
        <!-- <div class="barrage-list barrage-list_0 barrage-list_01"> -->
            <div class="barrage-list_box">
                <div class="barrage-list_con van-ellipsis">
                    <span>{{jinruData.nickName}}：</span>{{jinruData.content}}
                    <!-- <span>测试：</span>测试金额 -->
                </div>
            </div>
        </div>
        <!-- <div class="barrage-list barrage-list_2" :style="pinglunData.length>3?'height:6.6rem;':'height:'+2.2*(pinglunData.length)+'rem;'"> -->
        <!-- <div class="barrage-list barrage-list_2" :style="pinglunData.length>pinglunShu?'height:'+1.6*pinglunShu+'rem;':'height:'+1.6*(pinglunData.length)+'rem;'"> -->
        <div class="barrage-list barrage-list_2" v-if="contShow" :style="'max-height:'+plHeight+'px;'"  :class="zxpInfo&&zxpFlag?'boxHeight':''">
        <van-pull-refresh v-model="isLoading" pulling-text=" " loosing-text=" " loading-text=" " @refresh="onRefresh" :disabled="plShow">
            <div class="barrage-box barrage-list_2 banAnim" ref="pinglun" :style="'max-height:'+(zxpInfo&&zxpFlag?plHeight-100:plHeight)+'px;'" >
                <template v-for="(item,index) in pinglunData">
                    <div class="barrage-list_box" :key="index">
                        <div class="barrage-list_con">
                            <span>{{item.username}}<span v-if="item.uid!=''">：</span></span>{{item.content}}
                        </div>
                    </div>
                </template>
            </div>
        </van-pull-refresh>
        </div>
    </div>
</template>

<script>
export default {
    props:["zxpFlag","zxpInfo","barrageShow","chujiaData","pinglunData","jinruData","jinruClass","plShow","baseList","plHeight","jinBottom","jinerBottom","chujiaClass"],
    data() {
        return {
            isLoading:false,
            contShow: this.barrageShow, //显示
            pinglunShu:6,//评论数
        };
    },
    created: function() {
    },
    methods: {
        barrageFun(show){
            this.contShow=show;
        },
        jiapl(){//自动滚动到底部
            var div=this.$refs.pinglun                   
            //此时必须异步执行滚动条滑动至底部
            var olds=div.scrollTop
            setTimeout(()=>{
                var news = div.scrollHeight-div.offsetHeight;
                this.jiaFun(olds,news)
            },0)
        },
        ding(){//回到顶部
            var div=this.$refs.pinglun
            this.dingFun(div.scrollTop)
            //console.log(div.scrollTop)
        },

        dingFun(shu) {//回到顶部方法
            var _this=this;
            if(shu>0){
                setTimeout(function () {
                    shu--
                    _this.$refs.pinglun.scrollTop=shu
                    _this.dingFun(shu);
                }, 10)
            }
        },
        jiaFun(olds,news) {//回到底部方法
            var _this=this;
            if(olds<news){
                setTimeout(function () {
                    //console.log(olds+'-----'+news)
                    olds++
                    _this.$refs.pinglun.scrollTop=olds
                    _this.jiaFun(olds,news);
                }, 10)
            }
        },
        onRefresh() {
            this.$parent.getLivecommentlist()
            this.isLoading=false
        },

    },
};
</script>

<style lang="scss" scoped>
.boxHeight{
    bottom: 8rem !important;
}
.barrage-list{
    /* width:100%;
    overflow:hidden;
    position:relative;
    transition : 0.6s ease all; */
    width: 94%;
    height:auto;
    position: fixed;
    left: 3%;
    z-index:6;
}
.banAnim{
    transition: all 0s ease !important;
}
.barrage-box{
    width:100%;
    /* position:absolute;
    left:0px;
    top:0rem; */
    transition : 0.6s ease all;
    height:100%;
    overflow-x: hidden;
    overflow-y: scroll;
}
.barrage-list_box{
    width:100%;
    overflow: hidden;
    margin-bottom:0.3rem;
}
.barrage-list_con{
    float: left;
    max-width:100%;
    padding:0.1rem 0.6rem;
    font-size:0.7rem;
    border-radius:20px;
    line-height:1.1rem;
    color:#fff;
    display:inline-block;
}
.barrage-list_0 .barrage-list_con{
    font-size:0.7rem;
    line-height:1.1rem;
    padding-bottom:0.1rem;
}
.barrage-list_1 .barrage-list_con{
    font-size:0.6rem;
    line-height:1rem;
}
.barrage-list_0{
    height:2.2rem;
    bottom:14.7rem;
    transition : 0.6s ease all;
    left:-110%;
    margin:0.6rem 0rem 0rem;
}
.barrage-list_1{
    bottom: 17.6rem;
    height:4.5rem;
    left:-100%;
}
.barrage-list_1_1{
    left:3%;
    transition : 0.6s ease all;
    width:66%;
}
.barrage-list_2{
    bottom: 3.8rem;
    height:auto;
    max-height:9.6rem;
}
.barrage-list_01{
    left:3%;
}
.barrage-list_02{
    left:3%;
    opacity:0;
}
.barrage-list_03{
    left:-110%;
    opacity:0;
}
.barrage-list_0 .barrage-list_con{
    /* background: linear-gradient(134deg, #ffc574 0%, #df8303 100%); */
    background: rgba(250, 84, 28, 0.7);
}
.barrage-list_1 .barrage-list_con{
    background:rgba(255, 59, 48, 0.5);
}
.barrage-list_2 .barrage-list_con{
    background:rgba(0, 0, 0, 0.6);
}
.barrage-list_2 .barrage-list_con span{
    color:#18BD6F;
}
</style>